<template>
	<b-form @submit.stop.prevent="save($event)">
		<b-form-row>
			<b-col cols="12" lg="6">
				<b-card class="mb-3">
					<b-form-row>
						<b-col>
							<b-form-checkbox v-model="settings.stackViewerCounts">Stack viewer counts</b-form-checkbox>
							<b-form-checkbox v-model="settings.showDisabledChannels">Show disabled channels</b-form-checkbox>
							<b-form-checkbox v-model="settings.logoOnRight">Platform logo on right</b-form-checkbox>
						</b-col>
						<b-col>
							<b-form-checkbox v-model="settings.showOfflineChannels">Show offline channels</b-form-checkbox>
							<b-form-checkbox v-model="settings.showOnlyVerifiedChannels">Show only verified channels</b-form-checkbox>
						</b-col>
					</b-form-row>
				</b-card>
				<text-settings :settings="settings" />
				<b-card title="Outline" class="mb-3">
					<b-form-row>
						<b-col>
							<b-form-group label="Blur radius">
								<b-input-group append="px">
									<b-form-input type="number" min="0" max="100" step="any" v-model.number="settings.blurRadius"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Spread radius">
								<b-input-group append="px">
									<b-form-input type="number" min="0" max="100" step="any" v-model.number="settings.spreadRadius"></b-form-input>
								</b-input-group>
							</b-form-group>
						</b-col>
						<b-col cols="6">
							<b-form-group label="Outline Color">
								<color-picker v-model="settings.shadowColor" />
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-card>
				<b-card title="Colors" class="mb-3">
					<b-form-row>
						<b-col>
							<b-form-group label="Text Color">
								<color-picker v-model="settings.textColor" />
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group label="Item Background">
								<color-picker v-model="settings.textBg" />
							</b-form-group>
						</b-col>
					</b-form-row>
				</b-card>
				<b-card class="mb-3">
					<b-form-group label="Extra CSS">
						<b-textarea v-model="settings.extraCSS"></b-textarea>
					</b-form-group>
				</b-card>
			</b-col>
			<b-col cols="12" lg="6">
				<preview class="mb-3" slug="viewerCount" name="Viewer count" />
			</b-col>
		</b-form-row>
		<b-card class="text-center mb-3">
			<b-alert variant="danger" :show="!!saveError">{{saveError}}</b-alert>
			<b-overlay :show="saving > 0" variant="dark" class="d-inline-block">
				<b-button variant="primary" type="submit">Save settings</b-button>
			</b-overlay>
			<b-button @click="copyStyleFromChatWidget()" :disabled="copyingStyle" class="ml-3">Copy style from chat widget</b-button>
		</b-card>
	</b-form>
</template>

<script>
import ColorPicker from '@/components/ColorPicker.vue';
import Preview from '@/components/Widget/Preview.vue';
import TextSettings from '@/components/Widget/TextSettings.vue';

export default {
	data() { return {
		settings: {},
		error: null,
		loading: 0,
		saveError: null,
		saving: 0,
		curColor: {},
		copyingStyle: false,
	}},
	components: {
		ColorPicker,
		Preview,
		TextSettings,
	},
	async mounted() {
		try {
			this.loading++;
			this.error = null;
			this.saveError = null;
			const settings = await this.$api.get('widgetSettings/viewer-count');
			this.settings = {
				stackViewerCounts: settings.stackViewerCounts || false,
				showDisabledChannels: settings.showDisabledChannels || false,
				logoOnRight: settings.logoOnRight || false,
				showOfflineChannels: settings.showOfflineChannels || false,
				showOnlyVerifiedChannels: settings.showOnlyVerifiedChannels || false,
				textColor: settings.textColor || 'rgba(255, 255, 255, 1)',
				shadowColor: settings.shadowColor || 'rgba(0, 0, 0, 1)',
				textBg: settings.textBg || 'rgba(0, 128, 0, 0)',
				blurRadius: settings.blurRadius || 0,
				spreadRadius: settings.spreadRadius || 0,
				boldText: settings.boldText || false,
				extraCSS: settings.extraCSS || '',
				fontFamily: settings.fontFamily || '',
				fontSize: settings.fontSize || 0,
				italicText: settings.italicText || false,
				letterSpacing: settings.letterSpacing || 0,
				lineHeight: settings.lineHeight || 0,
				strikethroughText: settings.strikethroughText || false,
				textAlign: settings.textAlign || 'left',
				underlineText: settings.underlineText || false,
				customFont: settings.customFont || true,
			};
		} catch(e) {
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async save() {
			try {
				this.saving++;
				this.saveError = null;
				await this.$api.post('widgetSettings/viewer-count', { ...this.settings });
			} catch(e) {
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
		async copyStyleFromChatWidget() {
			try {
				this.loading++;
				this.copyingStyle = true;
				this.error = null;
				const settings = await this.$api.get('widgetSettings/chat');
				this.settings.blurRadius = settings.blurRadius || 0;
				this.settings.spreadRadius = settings.spreadRadius || 0;
				this.settings.boldText = settings.boldText || false;
				this.settings.extraCSS = settings.extraCSS || '';
				this.settings.fontFamily = settings.fontFamily || '';
				this.settings.fontSize = settings.fontSize || 0;
				this.settings.italicText = settings.italicText || false;
				this.settings.letterSpacing = settings.letterSpacing || 0;
				this.settings.lineHeight = settings.lineHeight || 0;
				this.settings.shadowColor = settings.shadowColor ||  'rgba(0, 0, 0, 1)';
				this.settings.strikethroughText = settings.strikethroughText || false;
				this.settings.textAlign = settings.textAlign || 'left';
				this.settings.textBg = settings.textBg || 'rgba(0, 128, 0, 0)';
				this.settings.textColor = settings.textColor || 'rgba(255, 255, 255, 1)';
				this.settings.underlineText = settings.underlineText || false;
				this.settings.customFont = settings.customFont || false;
			} catch(e) {
				this.error = e;
			} finally {
				this.copyingStyle = false;
				this.loading--;
			}
		},
	},
};
</script>
